import axios from "../shared";
import React, { useState } from "react";
import InputField from "../Components/InputField";
import AlertField from "../Components/AlertField";

const ContactUs = () => {
  const [values, setValues] = useState({});
  const [alert, setAlert] = useState({});

  const inputs = [
    {
      id: 1,
      name: "name",
      type: "text",
      placeholder: "Enter your name",
      errorMessage: "Name shouldn't include any special character!",
      label: "Name",
      pattern: "^[A-Za-z ]{3,50}$",
      required: true,
    },
    {
      id: 2,
      name: "email",
      type: "email",
      placeholder: "Enter your email",
      errorMessage: "Enter a valid email address!",
      label: "Email Address",
      required: true,
    },
    {
      id: 3,
      name: "contact",
      type: "text",
      placeholder: "Enter your contact number",
      errorMessage: "Enter a valid contact number.",
      label: "Contact No.",
      required: true,
    },
  ];

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("auth/contact", values);
      showAlert("Message Sent", "success");
    } catch (err) {
      showAlert("No Server Response", "warning");
    }
  };
  return (
    <>
      <AlertField alert={alert} />
      <div className="mx-md-5 mt-3 px-md-5 px-4 d-flex flex-column align-items-center">
        <h2>Contact Us</h2>
        <p className="text-center">
          If you have a question regarding our service, location or anything
          else, we are ready to assist you.
        </p>
        <div className="bg-light px-4 px-md-5 py-2 w-100 d-flex justify-content-center">
          <form className="text-start" onSubmit={onSubmit}>
            {inputs.map((input) => (
              <InputField
                key={input.id}
                {...input}
                value={values[input.name]}
                onChange={onChange}
              />
            ))}
            <div>
              <label>Message</label>
              <textarea
                className="w-100 p-2"
                name="message"
                value={values.message}
                onChange={onChange}
                rows={4}
                placeholder="Enter your message..."
              ></textarea>
            </div>
            <div className="text-center my-3">
              <button className="btn btn-primary">Send Message</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
